// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"654c379f","317":"6945987f","735":"8d29ad77","974":"49ae05c1"}[chunkId] + ".chunk.js";
};